import { ApiResourceBaseClass as e } from "./baseApiCalls.js";
const r = "publisher";
class i extends e {
  /**
   * Retrieves a list of publishers for the current authenticated user.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/publisher`
   *
   * @returns {Promise<Array<PublisherRawData>>} A promise resolving to an array of publisher data.
   */
  getPublishersForUser = async () => {
    const {
      data: { publishers: s }
    } = await this.get(`${r}`);
    return s;
  };
}
export {
  i as Publisher
};
